import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../App';
import DonateModal from '../common/DonateModal';

const translations = {
  en: {
    title: 'Your Support, Someone\'s New Beginning',
    subtitle: 'We are committed to helping the underprivileged sections of society. Let\'s build a better tomorrow together.',
    donate: 'Donate',
    volunteer: 'Become a Volunteer'
  },
  hi: {
    title: 'आपका साथ, किसी की ज़िंदगी की शुरुआत',
    subtitle: 'हम समाज के वंचित वर्गों की मदद के लिए प्रतिबद्ध हैं। आइए मिलकर एक बेहतर कल का निर्माण करें।',
    donate: 'दान करें',
    volunteer: 'स्वयंसेवक बनें'
  }
};

const Hero: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);
  const t = translations[language];

  return (
    <section className="relative min-h-[80vh] flex items-center bg-gradient-to-r from-primary/10 to-secondary/10 section-padding overflow-hidden">
      {/* Krishna Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/radhekrishna.jpg"
          alt="Lord Krishna"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/40 to-secondary/40" />
      </div>

      <div className="container-custom relative z-10">
        <div className="flex flex-col items-center text-center">
          <motion.h1 
            className="text-4xl md:text-6xl font-baloo font-bold text-gray-800 mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t.title}
          </motion.h1>
          
          <motion.p 
            className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t.subtitle}
          </motion.p>
          
          <motion.div 
            className="flex flex-col sm:flex-row gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <button 
              className="btn-primary text-lg transform hover:scale-105 transition-transform duration-300"
              onClick={() => setIsDonateModalOpen(true)}
            >
              {t.donate}
            </button>
            <button 
              className="btn-secondary text-lg transform hover:scale-105 transition-transform duration-300"
              onClick={() => navigate('/volunteer')}
            >
              {t.volunteer}
            </button>
          </motion.div>
        </div>
      </div>

      {/* Animated background elements */}
      <motion.div 
        className="absolute top-0 left-0 w-32 h-32 bg-primary/5 rounded-full"
        animate={{
          x: [-50, 0, -50],
          y: [-50, 0, -50],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <motion.div 
        className="absolute bottom-0 right-0 w-40 h-40 bg-secondary/5 rounded-full"
        animate={{
          x: [50, 0, 50],
          y: [50, 0, 50],
          scale: [1, 1.3, 1],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "linear"
        }}
      />

      <DonateModal 
        isOpen={isDonateModalOpen}
        onClose={() => setIsDonateModalOpen(false)}
      />
    </section>
  );
};

export default Hero; 